import { jsx } from '@emotion/react/jsx-runtime';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { IconButton } from './icon-button.js';

/**
 * A special icon button used for dismissing alerts, dialogs, toasts, etc.
 */ const DismissButton = createPolymorphicComponent((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('DismissButton', props, ref);
    const { 'aria-label': ariaLabel = 'Dismiss', as = 'button', ...iconButtonProps } = mergedProps;
    return /*#__PURE__*/ jsx(IconButton, {
        ...iconButtonProps,
        ref: mergedRef,
        "aria-label": ariaLabel,
        as: as,
        icon: faTimes,
        variant: "plain"
    });
});

export { DismissButton };
//# sourceMappingURL=dismiss-button.js.map
